import { ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { useTranslations } from 'next-intl'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

import type { FC } from 'react'

interface AlertErrorComponentProps {
  description?: string
}

export const AlertErrorComponent: FC<AlertErrorComponentProps> = ({ description }) => {
  const t = useTranslations('Common.Components.alert')

  const alertDescription = description || t('error.description')

  return (
    <Alert variant="destructive">
      <ExclamationTriangleIcon className="h-4 w-4" />
      <AlertTitle>{t('error.title')}</AlertTitle>

      <AlertDescription>{alertDescription}</AlertDescription>
    </Alert>
  )
}
